import React from 'react'
import useOffsets from '@/hooks/useOffsets'
import { useTheme } from '@/hooks/useTheme'
import { Toaster } from 'react-hot-toast'

const ToasterProvider = ({ children }: { children: React.ReactNode }) => {
  const offsets = useOffsets()
  const theme = useTheme()
  return (
    <>
      {children}
      <Toaster
        position="top-center"
        containerStyle={{
          top: offsets.top + 30,
          left: 13,
          right: 13,
          // border-radius
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: theme.colors.background.secondaryGray,
            color: theme.colors.label.default,
            border: `1px solid ${theme.colors.background.secondaryGrayOpacity01}`,
          },
        }}
      />
    </>
  )
}

export default ToasterProvider
